import { isBuiltInToken } from "~/pages/Trade/utils";

const chainKeyList = [
    {
        chainId: 2652501241,
        chainKey: "lightning",
        chainName: "Lightning",
        chainSymbol: "SATS",
        chainAlliance: "lightning",
        chainDecimals: 3,
        chainRPCs: null,
        explorer: "",
        supportSwap: false,
    },
    {
        chainId: 1,
        chainKey: "ethereum",
        chainName: "Ethereum",
        chainSymbol: "ETH",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [
            "https://eth-mainnet.public.blastapi.io",
            "https://eth.llamarpc.com",
        ],
        explorer: "https://etherscan.io/",
        supportSwap: true,
    },
    {
        chainId: 56,
        chainKey: "bnbchain",
        chainName: "BNB Chain",
        chainSymbol: "BNB",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: ["https://bscrpc.com", "https://bsc-dataseed2.ninicoin.io"],
        explorer: "https://bscscan.com/",
        supportSwap: true,
    },
    {
        chainId: 239,
        chainKey: "ton",
        chainName: "Ton",
        chainSymbol: "TON",
        chainAlliance: "ton",
        chainDecimals: 9,
        chainRPCs: ["https://toncenter.com/api/v2/jsonRPC"],
        explorer: "https://tonviewer.com/",
        supportSwap: false,
    },
    {
        chainId: 728126428,
        chainKey: "tron",
        chainName: "Tron",
        chainSymbol: "TRX",
        chainAlliance: "tron",
        chainDecimals: 6,
        chainRPCs: [],
        explorer: "https://tronscan.org/",
        supportSwap: false,
    },
    {
        chainId: 8453,
        chainKey: "base",
        chainName: "Base",
        chainSymbol: "ETH",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://basescan.org/",
        supportSwap: false,
    },
    {
        chainId: 137,
        chainKey: "polygon",
        chainName: "Polygon",
        chainSymbol: "POL",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [
            "https://polygon.blockpi.network/v1/rpc/public",
            "https://rpc.ankr.com/polygon",
        ],
        explorer: "https://polygonscan.com/",
        supportSwap: false,
    },
    {
        chainId: 42161,
        chainKey: "arbitrumone",
        chainName: "Arbitrum",
        chainSymbol: "ETH",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://arbiscan.io/",
        supportSwap: false,
    },
    {
        chainId: 43114,
        chainKey: "avalanchec",
        chainName: "Avalanche",
        chainSymbol: "AVAX",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://snowscan.xyz/",
        supportSwap: false,
    },
    {
        chainId: 1116,
        chainKey: "core",
        chainName: "Core",
        chainSymbol: "CORE",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://scan.coredao.org/",
        supportSwap: false,
    },
    {
        chainId: 810180,
        chainKey: "zklink",
        chainName: "zkLink Nova",
        chainSymbol: "ETH",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://explorer.zklink.io/",
        supportSwap: false,
    },
    {
        chainId: 204,
        chainKey: "opbnb",
        chainName: "opBNB Chain",
        chainSymbol: "BNB",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: ["https://opbnb-rpc.publicnode.com"],
        explorer: "https://opbnbscan.com/",
        supportSwap: false,
    },
    {
        chainId: 200901,
        chainKey: "bitlayer",
        chainName: "Bitlayer",
        chainSymbol: "BTC",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: [],
        explorer: "https://www.btrscan.com/",
        supportSwap: false,
    },
    {
        chainId: 22776,
        chainKey: "map",
        chainName: "MAP Protocol",
        chainSymbol: "MAPO",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: ["https://rpc.maplabs.io"],
        explorer: "https://maposcan.io/",
        supportSwap: false,
    },
    {
        chainId: 6000001,
        chainKey: "solana",
        chainName: "Solana",
        chainSymbol: "SOL",
        chainAlliance: "sol",
        chainDecimals: 9,
        chainRPCs: [],
        explorer: "https://solscan.io/",
        supportSwap: false,
    },
    {
        chainId: 897796746,
        chainKey: "sui",
        chainName: "Sui",
        chainSymbol: "SUI",
        chainAlliance: "sui",
        chainDecimals: 9,
        chainRPCs: [],
        explorer: "https://suiscan.xyz/mainnet/",
        supportSwap: false,
    },
    {
        chainId: 33139,
        chainKey: "ape",
        chainName: "ApeChain",
        chainSymbol: "APE",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: ["https://apechain.calderachain.xyz/http"],
        explorer: "https://apechain.calderaexplorer.xyz/",
        supportSwap: false,
    },
    {
        chainId: 897790001,
        chainKey: "aptos",
        chainName: "Aptos",
        chainSymbol: "APT",
        chainAlliance: "aptos",
        chainDecimals: 8,
        chainRPCs: [],
        explorer: "https://explorer.aptoslabs.com/",
        supportSwap: false,
    },
    {
        chainId: 897790002,
        chainKey: "movement",
        chainName: "Movement",
        chainSymbol: "MOVE",
        chainAlliance: "aptos",
        chainDecimals: 8,
        chainRPCs: ["https://aptos.testnet.porto.movementlabs.xyz/v1"],
        explorer: "https://explorer.movementlabs.xyz/",
        supportSwap: false,
    },
    {
        chainId: 4200,
        chainKey: "merlin",
        chainName: "Merlin",
        chainSymbol: "BTC",
        chainAlliance: "evm",
        chainDecimals: 18,
        chainRPCs: ["https://rpc.merlinchain.io"],
        explorer: "https://scan.merlinchain.io/",
        supportSwap: false,
    },
];

export const getChainKey = (chain_id: string | number) => {
    return chainKeyList.find(
        (item) => String(item.chainId) === String(chain_id)
    )?.chainKey;
};

export const getProviderAlliance = (chain_id: string | number) => {
    return (
        chainKeyList.find((item) => String(item.chainId) === String(chain_id))
            ?.chainAlliance ?? "evm"
    );
};

export const getContract = (contract: string) => {
    return isBuiltInToken(contract) ? "0x0" : contract;
};
